<template>
  <ion-app>
    <div v-if="networkStatus">
      <vue-page-transition name="fade">
        <router-view></router-view>
      </vue-page-transition>
    </div>
    <div v-else>
      <OfflineWarning />
    </div>
  </ion-app>
</template>

<script>
// capacitor google auth
import "@codetrix-studio/capacitor-google-auth";
// css sheets
import "./style/fonts.css";
import "./style/global.css";
// moment
import moment from "moment";
moment.locale("pt-br");
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// components
import OfflineWarning from "./components/general/OfflineWarning.vue";
// store
import store from "./utils/store.js";
// capacitor
import { Plugins, AppState } from "@capacitor/core";
const { Device } = Plugins;
const { PushNotifications } = Plugins;
const { Network } = Plugins;
const { App } = Plugins;
const { LocalNotifications } = Plugins;

export default {
  name: "App",
  components: {
    OfflineWarning
  },
  data() {
    return {
      networkStatus: true,
      user: store.state.user
    };
  },
  async created() {
    const instance = this;

    // initialize store
    await store.signinUser();

    if (store.state.profile.id) {
      const now = moment().format("DD/MM/YYYY HH:mm");
      const userRef = db
        .collection("users")
        .doc(store.state.profile.id)
        .update({
          lastActive: now
        });
    }

    // handle network status change

    let handler = Network.addListener("networkStatusChange", async status => {
      instance.networkStatus = status.connected;
      if (status.connected) {
        await store.signinUser();
      }
    });

    // enable push notifications (only on mobile)

    const info = await Device.getInfo();
    if (info.platform === "ios" || info.platform === "android") {
      PushNotifications.register();

      PushNotifications.addListener("registration", token => {
        console.log(token);
      });

      PushNotifications.addListener("registrationError", error => {
        console.log(error);
      });

      PushNotifications.addListener(
        "pushNotificationReceived",
        notification => {
          let notif = this.state.notifications;
          notif.push({
            id: notification.id,
            title: notification.title,
            body: notification.body
          });
          this.setState({
            notifications: notif
          });
        }
      );

      // Method called when tapping on a notification
      PushNotifications.addListener(
        "pushNotificationActionPerformed",
        notification => {
          let notif = this.state.notifications;
          notif.push({
            id: notification.notification.data.id,
            title: notification.notification.data.title,
            body: notification.notification.data.body
          });
          this.setState({
            notifications: notif
          });
        }
      );
    }
  }
};
</script>